<script>
    import Button from '$lib/components/Button.svelte';
</script>

<div class="m-auto max-w-sm text-center">
    <h1 class="text-2xl font-semibold dark:text-purple-300">Page not found</h1>
    <p class="py-7 text-lg">Sorry, we can't find the page you're looking for or something has gone wrong.</p>
    <Button style="Primary" href="/">Go Home</Button>
</div>
